module.exports = __webpack_public_path__ + "static/img/unshare.af479dfa.svg";